export default {
  FETCH_SALE_REPORT: 'FETCH_SALE_REPORT',
  FETCH_SALE_REPORT_SUCCESS: 'FETCH_SALE_REPORT_SUCCESS',
  DOWNLOAD_SALE_REPORT: 'DOWNLOAD_SALE_REPORT'
}
